import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { BALL_LEVELS } from './skill-level-utils';

interface BallLevelFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export function BallLevelFilter({ value, onChange }: BallLevelFilterProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="flex items-center gap-2 shrink-0">
          {value ? value.charAt(0).toUpperCase() + value.slice(1) + ' Ball' : 'Ball Level'}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuRadioGroup value={value} onValueChange={onChange}>
          {BALL_LEVELS.map(level => (
            <DropdownMenuRadioItem key={level.value} value={level.value}>
              {level.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
